export default "__VITE_ASSET__$N10SR6T__"